/**
 * @global
 * @namespace
 */
class MergeIdea
{
	/** @type {PopupHelper} */
	_popupHelper = null;

	constructor()
	{
		let thisObj = this;
		this._popupHelper = new PopupHelper("#merge-idea-popup", {
			popupOKCallback: thisObj._submitRequest.bind(thisObj),
			resetFieldsCallback: thisObj._resetFields.bind(thisObj),
		});
	}

	open(endpoint, ideaName, ideaId)
	{
		this._popupHelper.open(endpoint, ideaName, ideaId);
	}

	_resetFields(endpoint, ideaName, ideaId)
	{
		$(`${this._popupHelper.containerSelector} .idea-name`).html(ideaName);
		$(`${this._popupHelper.containerSelector} .tick`).show();
		if (ideaId) {
			$(`${this._popupHelper.containerSelector} .tick[data-idea-id="${ideaId}"]`).hide();
		}
		$(`${this._popupHelper.containerSelector} [name="select-idea"]`).prop("checked", false);
	}

	_submitRequest(endpoint, ideaName, ideaId)
	{
		const $checkedIdea = $(`${this._popupHelper.containerSelector} input:checked[name="select-idea"]`);
		const otherIdeaId = $checkedIdea.val();
		
		const popupHelper = this._popupHelper;
		const data = {
			withIdeaId: otherIdeaId
		};
		popupHelper.showLoading();

		dataAction.callClientPostEndpoint(
			endpoint,
			data,
			function (response)
			{
				popupHelper.close();
				window.location.href = response;
			},
			popupHelper.defaultResponseErrorHandler.bind(popupHelper),
			popupHelper.hideLoading.bind(popupHelper)
		);
	}
}